import {Expose, Type} from "class-transformer";
import Model from "./Model";



export default class Attachment extends Model {

    @Expose({name: "width"})
    width: number;

    @Expose({name: "height"})
    height: number;

    @Expose({name: "url"})
    url: string;



}




// WEBPACK FOOTER //
// ./app/client/_data/models/Attachment.ts